export const styles = theme => ({
    root: {
      width: '90%',
      margin: '0 auto'
    },
    chart: {
      margin: "10px",
      padding: theme.spacing.unit * 2,
      textAlign: 'center',
      color: theme.palette.text.secondary,
      height: "100%"
    },
    detailsGrid: {
      marginTop: "8px"
    }
  });


// WEBPACK FOOTER //
// ./src/styles/details-panel-styles.js